<template>
  <layout-default-app-bar
    :back-to="isOrigemPedido ? '/cadastro-pedido' : false"
  >
    {{ titulo }}
  </layout-default-app-bar>
</template>

<script>
import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewListaPrecadastroAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  computed: {
    isOrigemPedido() {
      return this.$route.query.origem === 'pedido';
    },
    titulo() {
      return this.isOrigemPedido ? 'Selecionar Pré-Cadastro' : 'Clientes Pré-Cadastro';
    },
  },
};
</script>

<style scoped>
</style>
